export const directionTransformers: {
  [key in string]: (x: number, y: number) => { x: number; y: number };
} = {
  n: (x, y) => ({ x, y: y - 1 }),
  s: (x, y) => ({ x, y: y + 1 }),
  e: (x, y) => ({ x: x + 1, y }),
  w: (x, y) => ({ x: x - 1, y }),
  ne: (x, y) => ({ x: x + 1, y: y - 1 }),
  nw: (x, y) => ({ x: x - 1, y: y - 1 }),
  se: (x, y) => ({ x: x + 1, y: y + 1 }),
  sw: (x, y) => ({ x: x - 1, y: y + 1 }),
};
